var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scale"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.18,2H6.82A3.82,3.82,0,0,0,3,5.82V26.18A3.82,3.82,0,0,0,6.82,30H25.18A3.82,3.82,0,0,0,29,26.18V5.82A3.82,3.82,0,0,0,25.18,2ZM27,26.18A1.82,1.82,0,0,1,25.18,28H6.82A1.82,1.82,0,0,1,5,26.18V5.82A1.81,1.81,0,0,1,6.82,4H25.18A1.81,1.81,0,0,1,27,5.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,7.87a18.13,18.13,0,0,0-16,0,1.79,1.79,0,0,0-.8,2.38L8.52,13a1.8,1.8,0,0,0,1.11.93,1.72,1.72,0,0,0,1.4-.22,9.34,9.34,0,0,1,5-1.48,9.24,9.24,0,0,1,5,1.48,1.75,1.75,0,0,0,.94.28,1.89,1.89,0,0,0,.47-.06,1.79,1.79,0,0,0,1.1-.93l1.34-2.76A1.79,1.79,0,0,0,24,7.87Zm-2.22,4a11.08,11.08,0,0,0-11.6,0L9.07,9.57a16.08,16.08,0,0,1,13.86,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScale);
export default __webpack_public_path__ + "static/media/scale.c8be432558ec1c1ac1ffa1241e370e15.svg";
export { ForwardRef as ReactComponent };